<template>
    <div>
        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-6">
                <h4>Amati</h4>
            </div>
            <div class="col-sm-6 d-flex justify-content-end">
                <JobTitlesAdd/>
            </div>
        </div>
        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <JobTitlesList v-else/>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    import JobTitlesList from '@/components/job-titles/JobTitlesList';
    import JobTitlesAdd from '@/components/job-titles/JobTitlesAdd';
    import * as jobTitleStoreTypes from '../../vuex/modules/company/modules/job-titles/job-title.store-types';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
    import SkeletonLoader from '@/components/global/skeleton-loader/SkeletonLoader';

    export default {
        name: 'job-titles',
        components: {JobTitlesList, JobTitlesAdd, SkeletonLoader},
        data: () => ({searchTerm: '', skeletonData: SkeletonLoaderRepository.usersListLayout}),
        computed: {
            ...mapGetters('jobTitle', {
                /** @type {boolean|*} */
                isLoading: jobTitleStoreTypes.GET_IS_LOADING,
            })
        },
        methods: {
            // ...mapMutations('company', {
            //     /** @type {function|*} */
            //     setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS,
            // }),
            // ...mapActions('user', {
            //     /** @type {function|*} */
            //     getUsers: userStoreTypes.ACTION_GET_USERS,
            // }),
            /**
             * Search company by name with 500ms delay.
             */
            // attemptSearch() {
            //     clearTimeout(this.searchTimeout);

            //     this.searchTimeout = setTimeout(async () => {
            //         const users = await this.getUsers({companyId: this.$route.params.companyId, name: this.searchTerm});
            //         this.setCurrentCompanyUsers(users);
            //     }, 500);
            // },
        }
    }
</script>
